import axios from 'axios'
import NProgress from 'nprogress'
import store from '../store/store'
// import swal from 'sweetalert'
import { baseUrls } from './../const'

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})
apiClient.interceptors.request.use(
  config => {
    let url = config.url.split('?')[0]
    for (let key in baseUrls) {
      url = url.replace(baseUrls[key], '')
    }
    if (store.state.user.no_loading_request.join('').indexOf(url) < 0) {
      store.commit('user/SET_LOADING', 1)
      NProgress.start()
    }
    return config
  },
  error => {
    return error
  }
)

apiClient.interceptors.response.use(
  response => {
    var url = response.config.url.split('?')[0]
    for (let key in baseUrls) {
      url = url.replace(baseUrls[key], '')
    }
    if (store.state.user.no_loading_request.join('').indexOf(url) < 0) {
      store.commit('user/SET_LOADING', -1)
      NProgress.done()
    }
    return response
  },
  error => {
    store.commit('user/STOP_LOADING')
    NProgress.done()
    // swal({
    //   icon: 'error',
    //   title: error.response.statusText,
    //   type: 'error'
    // })
    return Promise.reject(error)
  }
)

export default apiClient
